import Component from '@ember/component';

export default class SharedDropZoneFilenamePreview extends Component {}
